import style from './search-item.module.scss';
import { TUser } from '../../../models/common';
import ProfilePhoto from '../profile-photo/profile-photo';

function SearchItem({ user, onClick }: { user: TUser; onClick: (user: TUser) => void }) {
  return (
    <div onClick={() => onClick(user)} className={style['container']}>
      <div className={style['user']}>
        <ProfilePhoto fontSize="0.875rem" height="24px" width="24px" radius="100%" user={user} />
        <div className={style['username']}>{user.username}</div>
      </div>
      <span className={style['member']}>Member</span>
    </div>
  );
}

export default SearchItem;
